











































































import { Mixins, Component } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { ObjectUtility } from "../../../../../../../base/utilities";
import { FormatObjectSelector, FormatObjectSelectorColumnTypes } from "../selectors";
import { ILinkedPageObjectSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IFormatObjectSelectFilterParameter } from "./";

@Component({
  components: {
    FormatObjectSelector
  }
})
export default class FormatObjectSelectDialog extends Mixins(DialogMixin) {
  items: ILinkedPageObjectSpecifiable[] = [];
  selectionObjects: ILinkedPageObjectSpecifiable[] = [];
  columns: FormatObjectSelectorColumnTypes[] = [];
  selectionColumns: FormatObjectSelectorColumnTypes[] = [];
  allowDuplication: boolean = false;
  allowMoveItems: boolean = false;
  filteres: IFormatObjectSelectFilterParameter[] = [];
  toCellString: (column: FormatObjectSelectorColumnTypes, row: ILinkedPageObjectSpecifiable, isSelectedSelector: boolean) => string = () => "";

  selectedItems: ILinkedPageObjectSpecifiable[] = [];
  selectedObjects: ILinkedPageObjectSpecifiable[] = [];

  confirmed: boolean = false;

  get hasFilteres(): boolean {
    return this.filteres.length > 0;
  }

  get filteredObjects(): ILinkedPageObjectSpecifiable[] {
    return this.filteres.some(f => f.enabled)
      ? this.selectionObjects.filter(o => this.filteres.some(f => f.enabled && f.filter(o)))
      : this.selectionObjects;
  }

  get hasSelectedItems(): boolean {
    return this.selectedItems.length > 0;
  }

  get isTopSelectedItem(): boolean {
    return this.hasSelectedItems && this.selectedItems.some(v => v === this.items[0]);
  }

  get isBottomSelectedItem(): boolean {
    return this.hasSelectedItems && this.selectedItems.some(v => v === this.items[this.items.length - 1]);
  }

  get hasSelectedObjects(): boolean {
    return this.selectedObjects.length > 0;
  }

  async show(
    items: ILinkedPageObjectSpecifiable[],
    selectionObjects: ILinkedPageObjectSpecifiable[],
    columns: FormatObjectSelectorColumnTypes[],
    selectionColumns: FormatObjectSelectorColumnTypes[],
    allowDuplication: boolean,
    allowMoveItems: boolean,
    filteres: IFormatObjectSelectFilterParameter[],
    toCellString: (column: FormatObjectSelectorColumnTypes, row: ILinkedPageObjectSpecifiable, isSelectedSelector: boolean) => string): Promise<ILinkedPageObjectSpecifiable[]> {
    return this.showModal(async () => {
      this.items = ObjectUtility.copyDeeply(items);
      this.selectionObjects = selectionObjects;
      this.columns = columns;
      this.selectionColumns = selectionColumns;
      this.allowDuplication = allowDuplication;
      this.allowMoveItems = allowMoveItems;
      this.filteres = ObjectUtility.copyDeeply(filteres);
      this.toCellString = toCellString;

      this.selectedItems = [];
      this.selectedObjects = [];

      this.confirmed = false;
      await this.waitHidden();
      const ret = this.confirmed ? this.items : null;
      this.items = [];
      this.selectionObjects = [];
      this.columns = [];
      this.selectionColumns = [];
      return ret;
    });
  }

  addObjects() {
    const filteredObjects = this.allowDuplication
      ? this.selectedObjects
      : this.selectedObjects.filter(s => !this.items.some(i =>
        i.pageKey === s.pageKey &&
        i.type === s.type &&
        i.id === s.id &&
        i.key === s.key &&
        i.subKey === s.subKey));
    this.items = this.items.concat(ObjectUtility.copyDeeply(filteredObjects));
  }

  moveItems(offset: number) {
    const indexes = this.selectedItems.map(v => this.items.indexOf(v)).sort((a, b) => a - b);
    if (offset > 0) {
      indexes.reverse();
    }
    indexes.forEach(i => this.moveItem(i, offset));
  }

  private moveItem(index: number, offset: number) {
    const item = this.items[index];
    this.items.splice(index, 1);
    this.items.splice(index + offset, 0, item);
  }

  removeItems() {
    this.items = this.items.filter((v) => !this.selectedItems.some(s => s === v));
  }

  changeItems(value: ILinkedPageObjectSpecifiable[]) {
    this.selectedItems = value;
  }

  changeObjects(value: ILinkedPageObjectSpecifiable[]) {
    this.selectedObjects = value;
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
